class DashboardPassWord {
    constructor(password) {
        this.value = password
    }
}

module.exports = DashboardPassWord